<mat-drawer-container class="example-container">
  <mat-drawer #drawer class="example-sidenav" mode="side" position="end">
    <app-user-manual [openPanel]="true" (closePanel)="getToggleData($event, drawer)"
      [userManual]="userManualId"></app-user-manual>
  </mat-drawer>

  <div class="example-sidenav-content">
    <avantor-header (toggleUserData)="getToggleData($event, drawer)"></avantor-header>
    <div class="fixed-header min-vh-100">
      <router-outlet></router-outlet>
    </div>
    <avantor-footer></avantor-footer>
  </div>
</mat-drawer-container>